export enum IconSize {
  Xxs = 'f-i-xxs',
  Xs = 'f-i-xs',
  Sm = 'f-i-sm',
  Md = 'f-i-md',
  Lg = 'f-i-lg',
  Xl = 'f-i-xl',
  Xxl = 'f-i-xxl'
}
